module.exports = __webpack_public_path__ + "img/1f97b.83dca4c.svg";